export default {
  baseStyle: {
    _placeholder: {
      color: 'dark.500'
    }
  }
}
